import { render } from "./ApiManagement.vue?vue&type=template&id=5ddef024&scoped=true"
import script from "./ApiManagement.vue?vue&type=script&lang=js"
export * from "./ApiManagement.vue?vue&type=script&lang=js"

import "./ApiManagement.vue?vue&type=style&index=0&id=5ddef024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddef024"]])

export default __exports__